import Vue from 'vue'
import moment from 'moment'

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // Break integer part every 3 digits
  return intPartFormat
})

export function FenToDong(value) {
  if (value === null || value === undefined || value === '') {
    return '0'
  }

  const num = Number(value)
  if (Number.isNaN(num)) {
    return '0'
  }

  // Vietnam region: use dot as thousands separator, comma as decimal separator, keep 2 decimal places, add VND currency symbol₫
  const parts = num.toFixed(2).split('.')
  // Add thousands separator (dot) to integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  // Combine: integer part,Decimal part (Vietnam format)
  return parts[0] + ',' + parts[1] + ' ₫'
}

Vue.filter('FenToDong', FenToDong)

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

// Phone number masking filter: keep first3Digits and after4Digits, middle use*Replace
Vue.filter('maskPhone', function (value) {
  if (!value) {
    return ''
  }
  const phone = String(value)
  if (phone.length <= 7) {
    return phone
  }
  return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4)
})
